module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/microsoft-windows.ea4e1d80.svg";